import { TeamAccessDTO } from '../team/team-access.dto';
import { ProductVersionListDTO } from '../product-version/product-version-list.dto';
import { ProductCheckpointListDTO } from '../product-checkpoint/product-checkpoint-list.dto';
import { ProductTestAnswerListDTO } from '../product-test-answer/product-test-answer-list.dto';
import { UserListDTO } from '../user/user-list.dto';

export class ProductTestDTO extends TeamAccessDTO {

    title: string;

    description: string;

    successful: boolean;

    version: ProductVersionListDTO;

    checkpoints: Array<ProductCheckpointListDTO>;

    answers: Array<ProductTestAnswerListDTO>;

    users: Array<UserListDTO>;

}
